import { render, staticRenderFns } from "./add-price.vue?vue&type=template&id=7e7db7ff&scoped=true&"
import script from "./add-price.vue?vue&type=script&lang=js&"
export * from "./add-price.vue?vue&type=script&lang=js&"
import style0 from "./add-price.vue?vue&type=style&index=0&id=7e7db7ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7db7ff",
  null
  
)

export default component.exports